/**
 * The meanings a source column can be given (mirrors EPN.PayrollReview.Api MappingRoles). The server sends the
 * list of choices (MappingTargetResponse); these constants only name the few roles the screen has to reason
 * about (the required-roles checklist, tax detail, hours, and the suggestion-only deduction role).
 */
export const ROLE = {
  EmployeeId: 'EmployeeId',
  FirstName: 'FirstName',
  LastName: 'LastName',
  FullName: 'FullName',
  RunId: 'RunId',
  PayDate: 'PayDate',
  PeriodStart: 'PeriodStart',
  PeriodEnd: 'PeriodEnd',
  PayrollType: 'PayrollType',
  StatedGross: 'StatedGross',
  StatedNet: 'StatedNet',
  StatedEmployeeTaxes: 'StatedEmployeeTaxes',
  StatedDeductions: 'StatedDeductions',
  PaymentMethod: 'PaymentMethod',
  PaymentReference: 'PaymentReference',
  Hours: 'Hours',
  Earning: 'Earning',
  Reimbursement: 'Reimbursement',
  EmployeeTax: 'EmployeeTax',
  EmployerTax: 'EmployerTax',
  PreTaxDeduction: 'PreTaxDeduction',
  PostTaxDeduction: 'PostTaxDeduction',
  EmployerContribution: 'EmployerContribution',
  Ignore: 'Ignore',
  DeductionNeedsClassification: 'DeductionNeedsClassification',
} as const;

/** Roles that may be given to at most one column. */
export const SINGLE_USE_ROLES: ReadonlySet<string> = new Set([
  ROLE.EmployeeId, ROLE.FirstName, ROLE.LastName, ROLE.FullName, ROLE.RunId, ROLE.PayDate, ROLE.PeriodStart,
  ROLE.PeriodEnd, ROLE.PayrollType, ROLE.StatedGross, ROLE.StatedNet, ROLE.StatedEmployeeTaxes,
  ROLE.StatedDeductions, ROLE.PaymentMethod, ROLE.PaymentReference,
]);

export const JURISDICTION_LEVELS = ['Federal', 'State', 'Local', 'Other'] as const;
export const RATE_TYPES = ['Regular', 'Overtime', 'DoubleTime', 'Other'] as const;

/** US state, DC and territory postal codes; only used to check a State Code field. */
export const US_STATE_CODES: ReadonlySet<string> = new Set([
  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN',
  'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA',
  'WV', 'WI', 'WY', 'AS', 'GU', 'MP', 'PR', 'VI',
]);

/** Roles whose column becomes one money line per employee per pay run (and so may carry an optional label). */
export const LINE_ROLES: ReadonlySet<string> = new Set([
  ROLE.Earning, ROLE.Reimbursement, ROLE.EmployeeTax, ROLE.EmployerTax, ROLE.PreTaxDeduction, ROLE.PostTaxDeduction, ROLE.EmployerContribution,
]);
